module.exports = __webpack_public_path__ + "img/912x482.1423ae2e.jpg";